import React, { useEffect } from "react";
import addUploadIcon from "../../assets/Icons/addUploadIcon.svg";
import addBulkUploadIcon from "../../assets/Icons/addBulkUploadIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";

import AdminAppBar from "./AdminAppBar";
import BackArrow from "../Form/BackArrow/BackArrows.jsx";
import AppBar from '../leadComponent/AppBar.jsx';
import { toast, ToastContainer } from "react-toastify";

const AdminLeadUploadPanel = () => {
  const navigate = useNavigate();

  const handleManualClick = () => {
    if(userRole === "Admin"){

      navigate("/admin/lead-upload/manual");
    }else if(userRole === "BOD"){
      navigate('/bod/lead-upload/manual')
    }else if(userRole === "Lead Uploader")
      navigate('/lead-uploader/lead-upload/manual')

  };

  const handleBulkUploadClick = () => {
    if(userRole === "Admin"){

      navigate("/admin/lead-upload/bulk");
    }else if(userRole === "BOD"){
      navigate('/bod/lead-upload/bulk')
    }else if(userRole === "Lead Uploader")
      navigate('/lead-uploader/lead-upload/bulk')  };
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {



        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;


  const handleBack = () => {
    if(userRole === "Admin"){

      navigate("/admin/lead-db");
    }else if (userRole === "CMO"){
      navigate("/cmo/lead-db");

    }else if (userRole === "Lead Uploader"){
      navigate("/lead-uploader");

    }else if (userRole === "BOD"){
     navigate("/bod/dashboard");
    }
  };
  return (
  <div className=" h-screen  bg-appGrayBackground pt-28 xl:pt-32 2xl:pt-24 lg:pt-20  ">
    <AdminAppBar/>
    {userRole === "Admin" || userRole === "BOD" ? <AdminAppBar/>: <AppBar/>}
    <ToastContainer />




    <div className=" container  w-full  h-full  ">

      <div className="container  ">
  <div className=" ">
{userRole != "Lead Uploader" && (

       <BackArrow handleBack={handleBack} />
)}


          <h2 className=" md:text-3xl lg:text-3xl l px-5 xl:mx-20  ml-16 lg:ml-0 font-semibold 4xl:text-4xl  ">
          Lead Upload Panel
        </h2>
        </div>




        <div className=" grid grid-cols-2 mx-40  mt-10 xl:h-[380px] xl:mt-5 2xl:h-[400px] 2xl:mt-20   lg:mt-3 items-center  shadow-md rounded-lg  h-[500px] bg-white 4xl:mt-24 4xl:h-[580px]  ">
        {/* h-[600px]  2xl:h-[450px] lg:h-[300px] */}
        <div className=" border-r h-full flex items-center border-gray-30 0 "
         onClick={handleManualClick}>

          <div

            className="cursor-pointer  items-center pl-40 2xl:pl-52 3xl:pl-64  4xl:pl-96 text-center flex flex-col"
          >
            <img className="w-20 h-20 3xl:w-32 3xl:h-32  " src={addUploadIcon} alt="" />
            <span className="text-3xl font-semibold whitespace-nowrap 3xl:text-4xl 4xl:text-5xl  ">Manual Add</span>
          </div>
        </div>

          {/* <div class="vertical-line border-r w-56 ml-20  border-gray-300 h-full"></div> */}
          <div className=""
            onClick={handleBulkUploadClick}

           >

          <div
            className="cursor-pointer flex flex-col text-center  items-center  gap-2 "
          >
            <img className="w-20 h-20 3xl:w-32 3xl:h-32  " src={addBulkUploadIcon} alt="" />
            <span className="text-3xl font-semibold whitespace-nowrap 3xl:text-4xl 4xl:text-5xl ">Bulk Upload</span>
            <span className="text-lg font-normal whitespace-nowrap 3xl:text-2xl">Excel/Google sheet</span>
          </div>

        </div>
          </div>

        <div className="  h-32 mb-1 flex items-center justify-center ">
          <p className="text-lg font-normal 3xl:text-2xl 4xl:text-3xl ">
            Note: Lead Uploaded here will be reflected in <br />
            <span className=" ml-74">admin panel as fresh lead</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  );
};

export default AdminLeadUploadPanel;
